export default __webpack_public_path__ + "static/media/HouseFour.328c7b97.jpg";